export const START_DATE_CHANGED = 'START_DATE_CHANGED';
export const END_DATE_CHANGED = 'END_DATE_CHANGED';
export const EMAIL_CHANGED = 'EMAIL_CHANGED';
export const FETCH_REGISTRATION_LOG_STARTED = 'FETCH_REGISTRATION_LOG_STARTED';
export const FETCH_REGISTRATION_LOG_SUCCESS = 'FETCH_REGISTRATION_LOG_SUCCESS';
export const FETCH_REGISTRATION_LOG_FAILED = 'FETCH_REGISTRATION_LOG_FAILED';

export const FETCH_USER_PROFILE_STARTED = 'FETCH_USER_PROFILE_STARTED';
export const FETCH_USER_PROFILE_SUCCESS = 'FETCH_USER_PROFILE_SUCCESS';
export const FETCH_USER_PROFILE_FAILED = 'FETCH_USER_PROFILE_FAILED';

export const FETCH_REGISTRATION_TIMELINE_STARTED =
  'FETCH_REGISTRATION_TIMELINE_STARTED';
export const FETCH_REGISTRATION_TIMELINE_SUCCESS =
  'FETCH_REGISTRATION_TIMELINE_SUCCESS';
export const FETCH_REGISTRATION_TIMELINE_FAILED =
  'FETCH_REGISTRATION_TIMELINE_FAILED';
